// The RFID tag barcode stored on an Inventory item (OPT-85), browser side.
//
// Only the store's own tags count (OPT-135): 8 digits starting 000.
// amplify/backend/function/funcBgRemovalWorker/src/tagBarcode.js holds the same
// two rules for the worker; tools/__tests__/tag-barcode-rule-parity.test.js
// pins the copies together. Keep them identical. No imports on purpose: the
// form component pulls this in, and the lookup lives in tagBarcodeLookup.js.

export const TAG_BARCODE_RULE_MESSAGE =
  "Barcode must be 8 digits starting 000 (e.g. 00005510)";

/** The store's tag format: the trimmed value if it is 8 digits starting 000, else null. */
export function normalizeTagBarcode(raw) {
  if (typeof raw !== "string") return null;
  const s = raw.trim();
  return /^000\d{5}$/.test(s) ? s : null;
}

/**
 * Uniqueness only binds items still in play: a tag is reused once its item
 * sells, so a Sold or Deleted holder does not count.
 */
export function isLiveForUniqueness(row) {
  const status = String((row && row.status) || "").toLowerCase();
  return status !== "sold" && status !== "deleted";
}
